import { render, staticRenderFns } from "./LayoutView.vue?vue&type=template&id=bfca4056"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"
import style0 from "./LayoutView.vue?vue&type=style&index=0&id=bfca4056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports